export const uz = {
    "n1": "Bosh sahifa",
    "n2": "Buyurtma",
    "n3": "tranzaksiya",
    "n4": "jamoa",
    "n5": "meniki",
    "t1": "nimadir noto'g'ri ketdi",
    "t2": "Muvaffaqiyatli nusxalandi",
    "t3": "Iltimos, ma'lumotlarni to'liq to'ldiring",
    "t4": "Yuklanmoqda…",
    "t5": "Kirish muvaffaqiyatli",
    "t6": "Taqdim etish uchun ball 3 dan katta bo'lishi kerak",
    "t7": "Yuborish muvaffaqiyatli",
    "t8": "Balans yetarli emas, qabul qilish mumkin emas",
    "t9": "Yuborilmadi",
    "t10": "Iltimos, avval manzilni bog'lang va siz shaxsiy markaz sahifasiga yo'naltirilasiz.",
    "t11": "Manzil bog'langan, uni o'zgartirish uchun mijozlarga xizmat ko'rsatish bilan bog'laning.",
    "t12": "Oʻzgartirish muvaffaqiyatli",
    "t13": "O‘zgartirish amalga oshmadi",
    "t14": "Parolingizni o'zgartirish uchun mijozlarga xizmat ko'rsatish bilan bog'laning",
    "t15": "Parol formatida xato",
    "t16": "Muvaffaqiyatli olib tashlang",
    "t17": "Yechib olish mumkin bo'lgan maksimal miqdor",
    "t18": "Minimal pul olish",
    "t19": "Ikkita parol bir-biriga mos kelmaydi",
    "t20": "Maslahatlar",
    "t21": "Ayni paytda sakrash imkonsiz",
    "t22": "Parol formatida xato",
    "t23": "Roʻyxatdan oʻtish muvaffaqiyatli",
    "t24": "Iltimos, hudud kodini kiriting",
    "t25": "Boshqa yo'q",
    "l1": "til",
    "l2": "Hisob raqamini kiriting",
    "l3": "Iltimos, parolni kiriting",
    "l4": "eslab qoling",
    "l5": "Kirish",
    "l6": "Ro'yxatdan o'tish uchun o'ting",
    "l7": "Hisob yo'q",
    "l8": "Mobil telefon raqami",
    "l9": "Taxallus",
    "l10": "Parol",
    "l11": "Parolni tasdiqlang",
    "l12": "Taklif kodi",
    "l13": "Roʻyxatdan oʻtish",
    "l14": "Allaqachon hisobingiz bor",
    "l15": "Loginga o'ting",
    "l16": "6-16 raqamli parolni kiriting",
    "bz1": "yordam",
    "bz2": "Tez-tez so'raladigan savollar",
    "bz3": "savdo qoidalari",
    "bz4": "Qanday qilib pul yechib olish mumkin",
    "bz5": "Qanday qilib to'ldirish kerak",
    "bz6": "1. TikTokShop nima?",
    "bz7": "TiktokShop - bu butun dunyo bo'ylab TiktokShop onlayn-do'koni sotuvchilariga ko'proq buyurtma sotishga yordam beradigan va TiktokShop onlayn-do'konini ko'rib chiqish ma'lumotlarini oshirishga yordam beradigan marketing kompaniyasi. Biz TiktokShop, savdogarlar va iste'molchilar o'rtasida uch tomonlama foydali marketing va reklama modelini o'rnatishga sodiqmiz. Eng yangi P2P blokcheyn texnologiyasi bilan birgalikda iste'molchilar va savdogarlar USDT (TRC20, ERC20) orqali tezda ulanadi. Ro'yxatdan o'tgan foydalanuvchilar buyurtmalar bo'yicha komissiya olishlari mumkin, savdogarlar esa o'z do'konlarining savdo ma'lumotlarini oshirishlari mumkin. Bu Internet blokcheyn modelidagi so'nggi foyda modeli!",
    "bz8": "2. TiktokShop qanday ishlaydi?",
    "bz9": "TiktokShop-dan kundalik fikr-mulohazalar shuni ko'rsatadiki, yaxshilanishi kerak bo'lgan mahsulotlar TiktokShop-da sotiladi. Foydalanuvchilar buyurtma ustiga osongina bosishlari kerak va tizim avtomatik ravishda buyurtma obunasini yaratadi. Foydalanuvchilar buyurtma miqdorini blokcheyn USDT orqali to'laydilar va kunlik komissiya oladilar.",
    "bz10": "3.Nima uchun ikkita tranzaksiyada bir xil valyutaning narxlari farqlanadi?",
    "bz11": "Narxlardagi farqlar valyutalarning erkin muomalasiga qulay bo‘lmagan barcha omillar, jumladan, valyuta o‘tkazmalari tezligi, tarmoq sharoitlari, valyutaga kirish cheklovlari, turli hududlardagi odamlar tomonidan valyutani tanib olish va hatto birjalar, tranzaksiyalar va boshqalar tomonidan taqdim etilgan savdo juftliklarining turlaridan kelib chiqadi.Shuning uchun bir xil valyuta turli operatsiyalarda narx farqiga ega bo‘lishi mumkin.",
    "bz12": "4. Investitsion foyda?",
    "bz13": "Siz olgan buyumning narxi qanchalik baland bo'lsa, buyurtma bo'yicha daromadingiz shunchalik yuqori bo'ladi. Shu bilan birga, TiktokShop katta komissiya buyurtmalarini tasodifiy taqsimlaydi.",
    "bz14": "Har kuni tizim avtomatik ravishda 60 ta mahsulot buyurtmasini ishlab chiqaradi va foydalanuvchilarga tarqatadi. Foydalanuvchilar har bir buyurtma uchun toʻlovni USDT orqali amalga oshiradilar va 0,6% komissiya oladilar. Katta komissiya buyurtmalari tasodifiy ravishda tayinlanadi.",
    "bz15": "USDT 60 ta buyurtmadan keyin yechib olinishi mumkin. (Agar 60 ta buyurtma bajarilmasa, tizim kunning qolgan buyurtmalarigacha avtomatik ravishda to'xtaydi)",
    "bz16": "Har bir hisob faqat bitta USDT hisobiga bog'lanishi mumkin. Agar xatolik yuzaga kelsa, iltimos, mijozlarga xizmat ko'rsatish xizmatiga murojaat qiling.",
    "bz17": "Kundalik buyurtmalarni yetkazib berishni tugatgandan so'ng, siz odatdagidek pul olishingiz mumkin. Pul yechib olingandan keyin 24 soat ichida keladi va yechib olish uchun hech qanday cheklov yo'q.",
    "bz18": "Zaryadlashdan oldin pul yechish manzilingizni (TRC-20 ni qo‘llab-quvvatlaydi) USDT manziliga bog‘lang. Siz APP yoki veb-sahifada zaryadlash tugmasini bosishingiz va zaryadlash uchun foydalanadigan blokcheynni (TRC-20) tanlashingiz mumkin.",
    "bz19": "Tegishli hisoblar o'rtasida o'zaro to'ldirish yoki o'zaro o'tkazishga yo'l qo'yilmaydi. Bu zararli buyurtmani tortib olish harakati va platformaning ishlash qoidalariga jiddiy ta'sir qiladi. Agar bunday xatti-harakatlar aniqlansa, tizim darhol hisobni muzlatib qo'yadi va ishni diskvalifikatsiya qiladi.",
    "bz20": "Bog'langan hisoblar keyingi kun uchun buyurtma vazifalarini yangilashni davom ettirishdan oldin har kunlik hisobdagi buyurtma vazifalarini bajarishi kerak. Agar bog'langan hisoblardan birida tugallanmagan vazifa bo'lsa, u buyurtma vazifalarini yangilashni to'xtatadi. Buyurtma topshiriqlarini barcha buyurtma vazifalari tugamaguncha yangilab bo'lmaydi.",
    "bz21": "Tegishli hisoblar o'rtasida to'ldirish yoki o'tkazishga ruxsat berilmaydi. Bu platformaning ishlash qoidalariga jiddiy ta'sir ko'rsatadigan zararli buyurtma olish harakati. Agar bunday xatti-harakatlar aniqlansa, tizim hisobni jarimaga tortadi. Birinchi jarima hisobdagi mablag'larning 15% ni tashkil qiladi. Zararli buyurtmani qayta-qayta tortib olish sizni bevosita ishlashdan mahrum qiladi.",
    "ty1": "OK",
    "ty2": "Bekor qilish",
    "ty3": "Yuborish",
    "ty4": "TRC20 manzili",
    "ty5": "ERC20 manzili",
    "s1": "Kümülatif daromad",
    "s2": "xizmat",
    "s3": "Biz haqimizda",
    "s4": "yordam",
    "s5": "Hamkorlar",
    "s6": "mening xizmatlarim",
    "d1": "Tugallanmagan",
    "d2": "Bajarildi",
    "d3": "Hozircha maʼlumot yoʻq",
    "d4": "Buyurtma raqami",
    "d5": "savdo soatlari",
    "d6": "Miqdori",
    "d7": "Joriy vazifalar soni",
    "d8": "kutilgan daromad",
    "d9": "Hali ham kerak",
    "d10": "Reyting",
    "j1": "Hisob balansi",
    "j2": "Savdoga kirish",
    "j3": "TiktokShop har kuni TiktokShop tomonidan sotiladigan va yaxshilanishi kerak bo'lgan mahsulotlarni namoyish qilish uchun TiktokShop fikr-mulohazalaridan foydalanadi. Foydalanuvchilar faqat buyurtma ustiga bosishlari kerak va tizim avtomatik ravishda buyurtma imzosini yaratadi. Foydalanuvchilar buyurtma miqdorini USDT blokcheyni orqali to‘laydilar va har safar 0,6% dan ortiq komissiya olishlari mumkin va tizim katta mukofot buyurtmalarini tasodifiy taqsimlaydi.",
    "j4": "Moslashni boshlang",
    "j5": "Bugungi daromad",
    "j6": "Bajarildi",
    "j7": "Vazifalarning umumiy soni",
    "td1": "Balans",
    "td2": "Komissiya",
    "td3": "qabul qilish",
    "td4": "odamlarning umumiy soni",
    "td5": "Foydalanuvchi",
    "td6": "Hissa qo‘shish",
    "td7": "Miqdori",
    "td8": "Status",
    "g1": "Naqd pul olish",
    "g2": "Zaryadlash",
    "g3": "Do'stlarni taklif qiling",
    "g4": "Hozir taklif qiling",
    "g5": "Do'stlaringiz ro'yxatdan o'tgandan keyin olgan har bir foyda uchun siz tegishli komissiya olasiz.",
    "g6": "shaxsiy ma'lumotlar",
    "g7": "Fond tafsilotlari",
    "g8": "Rekordni to'ldirish",
    "g9": "Olib tashlash yozuvlari",
    "g10": "til",
    "g11": "Chiqish",
    "g12": "Haqiqatan ham tizimdan chiqmoqchimisiz?",
    "yh1": "Foydalanuvchi ma'lumotlari",
    "yh2": "O'zgartirish",
    "yh3": "sozlamalar",
    "yh4": "telefon",
    "yh6": "Asl parol",
    "yh7": "yangi parol",
    "mx1": "Komissiya yig'imi",
    "mx2": "daromad",
    "mx3": "Olib tashlash rad etildi",
    "mx4": "vaqt",
    "mx5": "Toʻldirish muvaffaqiyatli",
    "mx6": "Rad etilgan",
    "mx7": "Kutilmoqda",
    "mx8": "Pul o'tkazish manzili",
    "mx9": "mavjud balans",
    "mx10": "Haqiqiy kelish",
    "mx11": "Iltimos, yechib olish miqdorini kiriting",
    "cz2": "Nusxalash",
    "cz3": "Fiat valyutasini tanlash",
    "cz4": "to'lash",
    "cz5": "Depozit manzili faqat TRC20-USDTni qo'llab-quvvatlaydi va minimal depozit miqdori 20USDT.",
    "cz6": "Depozit manzili faqat ERC20 ni qo‘llab-quvvatlaydi va minimal depozit miqdori 20USDT.",
    "cz1": "Depozit manzili faqat ERC20 ni qo‘llab-quvvatlaydi va minimal depozit miqdori 20USDT.",
    "qy1": "hudud kodi",
    "yq1": "Do'stlarni taklif qiling",
    "yq2": "Taklif kodi",
    "yq3": "Do'stlaringizni taklif qiling va katta imtiyozlardan foydalaning",
    "yq4": "Boring va taklif qiling",
    "zf1": "To'ldirish usuli",
    "zf2": "Toʻldirish usulini tanlang",
    "zf3": "savdo valyutalari",
    "zf4": "savdo tarmog'i",
    "zf5": "Savdoga boring",
    "zf6": "Muvaffaqiyatli nusxalandi",
    "zf7": "savdo valyutalari",
    "zf8": "Iltimos foydalaning",
    "zf9": "To'ldirishni yakunlash uchun quyidagi manzilga pul o'tkazing.",
    "zf10": "Tranzaksiya valyutasi",
    "zf11": "Nusxalash",
    "zf12": "Iltimos, manzilni diqqat bilan tekshiring. Agar siz uni noto'g'ri o'tkazsangiz, uni qayta tiklay olmaysiz.",
    "zf13": "Kelish vaqti",
    "zf14": "Taxminan 1-5 daqiqa",
    "zf15": "Minimal to'ldirish miqdori",
    "a1": "Do'kon marketing markazi",
    "a2": "Tik Shop do'koni marketing markazi savdogarlarga qisqa vaqt ichida o'z mahsulotlarini sotish va maqtov stavkalarini tezda oshirishga yordam berish uchun mo'ljallangan yangi bo'lim bo'lib, shu bilan mahsulotlarning og'irligini oshiradi va ularning ta'sirini yanada oshiradi; foydalanuvchilar savdogarlarga turli vazifalarni bajarish va tegishli mukofotlarni olish orqali yordam berishadi, shu bilan har ikki tomon uchun ham g'alaba qozonish holatiga erishadilar.",
    "a3": "Hozirda tizimda 40 million foydalanuvchi va 5 million savdogar mavjud va har kuni platformada reklama qilinadigan mahsulotlar soni 80 millionga etadi; ayrim savdo mahsulotlari marketing markazi tizimiga ulangan holda do‘kon savdosini 60% ga oshirdi; va marketing markazi tizimining platforma foydalanuvchilari faqat buyurtma ustiga bosishlari kerak va marketing markazi tizimi avtomatik ravishda buyurtma imzosini yaratadi. Foydalanuvchi buyurtma miqdorini oldindan to‘lagandan so‘ng virtual tranzaksiya yakunlanadi va mablag‘ darhol foydalanuvchining hisobiga qaytariladi. Har safar 0,6% dan ortiq qo'shimcha komissiya olish mumkin. Tizim, shuningdek, foydalanuvchi komissiyasini oshirish uchun tasodifiy ravishda katta mukofot buyurtmalarini ajratadi.",
    "a4": "Tik Shop foydalanuvchilar va savdogarlarning ehtiyojlariga katta ahamiyat beradi va marketing markazi tizimini optimallashtirish va takomillashtirishda davom etmoqda.",
    // Mijozlarga xizmat
    "kf1": "Onlayn mijozlarga xizmat ko'rsatish",
    "kf2": "Qo'lda pul yechish bo'yicha yordam",
    "kf3": "Pul yechish uchun mijozlarga xizmat ko'rsatish bilan bog'lanish uchun bu yerni bosing",
    "kf4": "Qo'lda to'ldirish bo'yicha yordam",
    "kf5": "To'ldirish uchun mijozlarga xizmat ko'rsatish bilan bog'lanish uchun bu yerni bosing",
    // To'lov imkoniyatlari oynasi
    "zf16": "Bank kartasi orqali operatsiyalar uchun mijozlarga xizmat ko'rsatish bilan bog'laning",
    "zf17": "Mijozlarga xizmat ko'rsatish bilan bog'lanish"
   }
  